module.exports = "https://files.cnvos.si/static/images/razvojno-sodelovanje.png?232934f6ddf95832a96399d3dde94731";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/razvojno-sodelovanje.png
// module id = 123
// module chunks = 1 2